export const VIN_WONDER_LIST_ACTION = "VIN_WONDER_LIST_ACTION";
export const VIN_WONDER_LIST_SUCCESS = "VIN_WONDER_LIST_SUCCESS";

export const VIN_WONDER_CREATE_ACTION = "VIN_WONDER_CREATE_ACTION";
export const VIN_WONDER_DELETE_ACTION = "VIN_WONDER_DELETE_ACTION";
export const VIN_WONDER_GET_UPDATE_ACTION = "VIN_WONDER_GET_UPDATE_ACTION";
export const VIN_WONDER_GET_UPDATE_SUCCESS = "VIN_WONDER_GET_UPDATE_SUCCESS";
export const VIN_WONDER_UPDATE_ACTION = "VIN_WONDER_UPDATE_ACTION";
export const VIN_WONDER_UPDATE_SUCCESS = "VIN_WONDER_UPDATE_SUCCESS";

export const VIN_WONDER_CREATE_TRANSLATE_ACTION = "VIN_WONDER_CREATE_TRANSLATE_ACTION";
export const VIN_WONDER_CREATE_TRANSLATE_SUCCESS = "VIN_WONDER_CREATE_TRANSLATE_SUCCESS";

export const VIN_WONDER_UPDATE_TRANSLATE_ACTION = "VIN_WONDER_UPDATE_TRANSLATE_ACTION";
export const VIN_WONDER_UPDATE_TRANSLATE_SUCCESS = "VIN_WONDER_UPDATE_TRANSLATE_SUCCESS";

export const VIN_WONDER_DELETE_TRANSLATE_ACTION = "VIN_WONDER_DELETE_TRANSLATE_ACTION";
export const VIN_WONDER_DELETE_TRANSLATE_SUCCESS = "VIN_WONDER_DELETE_TRANSLATE_SUCCESS";

export const VIN_WONDER_RESET = "VIN_WONDER_RESET";
export const VIN_WONDER_FAIL = "VIN_WONDER_FAIL";

export const VIN_WONDER_CHECK_ACTION = "VIN_WONDER_CHECK_ACTION";
export const VIN_WONDER_CHECK_SUCCESS = "VIN_WONDER_CHECK_SUCCESS";
export const VIN_WONDER_CHECK_FAIL = "VIN_WONDER_CHECK_FAIL";

export const VIN_WONDER_SITES_ACTION = "VIN_WONDER_SITES_ACTION";
export const VIN_WONDER_SITES_SUCCESS = "VIN_WONDER_SITES_SUCCESS";

export const VIN_WONDER_TYPES_ACTION = "VIN_WONDER_TYPES_ACTION";
export const VIN_WONDER_TYPES_SUCCESS = "VIN_WONDER_TYPES_SUCCESS";

export const VIN_WONDER_SESSION_ACTION = "VIN_WONDER_SESSION_ACTION";
export const VIN_WONDER_SESSION_SUCCESS = "VIN_WONDER_SESSION_SUCCESS";

export const VIN_WONDER_ZONE_ACTION = "VIN_WONDER_ZONE_ACTION";
export const VIN_WONDER_ZONE_SUCCESS = "VIN_WONDER_ZONE_SUCCESS";

